import React from 'react'
import Label from "../../../components/label/Label"
import Button from "../../../components/button/Button"
import { BUTTON_TYPE } from '../../../components/button/constants'
import Heading from "../../../components/heading/Heading"
import { HEADING } from '../../../components/heading/constants/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import { useDispatch, useSelector } from 'react-redux'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { setRowsPerPage, setSkip } from './PrePayHistorySlice'
import { componentKey } from './PrePayHistorySlice'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import styles from "./PrePayHistory.styles"
import { useEffect } from 'react'
import { exportPrepayExcel, getAdminAndMemberPrepay, getTransactions, processRefundRequest } from './PrePayHistorySaga'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { componentKey as DataLoaderComponentKey } from '../../loaders/dataloader/DataLoaderSlice'
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup'
import { useState } from 'react'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import Loadable from '../../../components/loadable/Loadable'
import { setShowPrepayWalletDrawer } from '../../dashboard/DashboardSlice'
import { COMMON_EXPORTING_STATES, COMMON_EXPORTING_STATES_MESSAGE_MAP, COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants'
import General from '../../../../libs/utility/General'

export default function PrePayHistory() {
	useGarbageCollector(componentKey)
	const { transactions, rowsPerPage, skip, exportFile, totalTransactions, loadingState, bifurcatedPrepayAmount } = useSelector((state) => state[componentKey])
	const { prepayAmount } = useSelector((state) => state[DataLoaderComponentKey])
	const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getTransactions({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1 }))
	}, [rowsPerPage, skip])

	useEffect(() => {
		dispatch(getAdminAndMemberPrepay());
	}, [prepayAmount]);
	
	const PREPAY_HISTORY_COLUMNS = [
		{
			field: "date",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Date</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TransactionDate}</span>
		},
		{
			field: "transactionType",
			header: <Label weight={LABEL_WEIGHT[700]}>Transaction Type</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TransactionType}</span>
		},
		{
			field: "prepayAmount",
			header: <Label weight={LABEL_WEIGHT[700]}>Paid Amount</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PrepayAmount}</span>
		},
		{
			field: "prepayBalanceOwner",
			header: <Label weight={LABEL_WEIGHT[700]}>Prepay Balance Owner</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PrepayBalanceOwner}</span>
		},
		{
			field: "prepayUsedBy",
			header: <Label weight={LABEL_WEIGHT[700]}>Prepay Used By</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PrepayUsedBy}</span>
		},
		{
			field: "prepayUsedFor",
			header: <Label weight={LABEL_WEIGHT[700]}>Transaction Details</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PrepayUsedFor}</span>
		},
	]

	const handleProcessRefundRequest = () => {
		setShowConfirmationPopup(false)
		dispatch(processRefundRequest())
	}
	const handleExport = () => {
		dispatch(exportPrepayExcel());
	}

	useEffect(() => {
		General.downloadFileWithBase64AndName(exportFile)
	}, [exportFile])
	return (
		<>
			<div style={styles.actionsRow}>
				<div style={styles.leftContainer}>
					<Heading type={HEADING.H1}>Prepay History</Heading>
					<Label customStyles={styles.text}>Prepay Balance: ${prepayAmount}</Label>
					<Label customStyles={styles.text}>Admin Prepay Available Balance: ${bifurcatedPrepayAmount?.adminPrepay}</Label>
					<Label customStyles={styles.text}>Member Users Prepay Balance: ${bifurcatedPrepayAmount?.memberPrepay}</Label>
				</div>
				<div style={styles.rightContainer}>
					<Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => setShowConfirmationPopup(true)}>Request Refund</Button>
					</Loadable>
					<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(setShowPrepayWalletDrawer(true))}>Prepay Now</Button>
					<Loadable currentState={loadingState.state} loadingStates={COMMON_EXPORTING_STATES.EXPORT_LOADING} messageMap={COMMON_EXPORTING_STATES_MESSAGE_MAP} isNewLoadable={true}>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={handleExport}>Export To Excel</Button>
					</Loadable>
				</div>
			</div>
			<div style={styles.grid}>
				<Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.GRID_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
					<RichGrid
						data={transactions}
						columns={PREPAY_HISTORY_COLUMNS}
						selectable={false}
						extractRowKey={(row) => row.Id}
						paginationProps={{
							skip: skip,
							take: rowsPerPage,
							takeOptions: ROW_SELECTION_OPTIONS,
							onChangeTakeCb: (newTake) => {
								dispatch(setRowsPerPage(newTake));
								dispatch(setSkip(0))
							},
							total: totalTransactions,
							onChange: (take, t) => {
								dispatch(setRowsPerPage(take));
								dispatch(setSkip(t))
							},
						}}
					/>
				</Loadable>
			</div>
			<ConfirmationPopup
				title={"Please Note"}
				bodyText={`You have $${prepayAmount} in your prepaid account. Do you want to refund?`}
				iconName={VEC_ICON_NAME.WARNING_ICON}
				isOpen={showConfirmationPopup}
				confirmationButtonProps={{
					onConfirmationCb: () => handleProcessRefundRequest(),
					confirmationButtonText: "Confirm",
					confirmationButtonStyles: {},
					confirmationButtonType: BUTTON_TYPE.PRIMARY,
				}}
				cancelButtonProps={{
					onCancelCb: () => setShowConfirmationPopup(false),
					cancelButtonText: "Cancel",
					cancelButtonStyles: {},
					cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
				}}
				showClose={false}
			/>
		</>
	)
}